import React, { useEffect, useRef, useState, startTransition } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { AccountsProvider, useAccounts } from '../GlobalContext'
import { masterTeam, memberRoles, deleteJob, getTeams, getMember } from '../appwrite/methods'
import { useAtom } from 'jotai';
import Popup from './Popup'
import {
    UserSession,
    UserMaster,
    UserOwner,
    TeamsList,
    CurrentTeam,
    TeamURL,
    logout,
    fetchTeams,
    TeamMember,
    sanitize,
    camelToKebab,
    camelToTitle,
    kebabToTitle,
    titleToKebab
} from '../utils'
import { Client, Teams, Storage, Databases, Account as AppAccount } from "appwrite";

import logo from "../assets/tom-logo-icon-black.jpg"
import PropTypes from 'prop-types';
import {
    Box,
    Stack,
    Typography,
    Avatar,
    Link as Weblink,
    Divider,
    MenuList,
    MenuItem,
    ListItemText,
    ListItemIcon,
    Chip,
    Button,
    Tooltip,
    Accordion,
    AccordionActions,
    AccordionDetails,
    AccordionSummary,
    Drawer,
    AppBar,
    Toolbar,
    IconButton,
    Badge,
    List,
    ListItem,
    ListItemButton,
    CssBaseline,
    LinearProgress,
    Snackbar,
    Alert,
    InputLabel,
    FormControl,
    Select
} from '@mui/material';
import { styled, useTheme, createTheme } from '@mui/material/styles';
import {
    AppProvider,
    DashboardLayout
} from '@toolpad/core';
import {
    Account,
    AccountPreview,
    AccountPopoverFooter,
    SignOutButton,
} from '@toolpad/core/Account';
// import { AuthenticationContext, SessionContext } from '@toolpad/core/AppProvider';

import DashboardIcon from '@mui/icons-material/Dashboard';
import AutoAwesomeMosaicOutlinedIcon from '@mui/icons-material/AutoAwesomeMosaicOutlined';
import SupervisorAccountOutlinedIcon from '@mui/icons-material/SupervisorAccountOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import WidgetsOutlinedIcon from '@mui/icons-material/WidgetsOutlined';
import DashboardCustomizeOutlinedIcon from '@mui/icons-material/DashboardCustomizeOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import DocumentScannerOutlinedIcon from '@mui/icons-material/DocumentScannerOutlined';
import LineWeightOutlinedIcon from '@mui/icons-material/LineWeightOutlined';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import RuleOutlinedIcon from '@mui/icons-material/RuleOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import ExploreOutlinedIcon from '@mui/icons-material/ExploreOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
// import MenuIcon from '@mui/icons-material/Menu';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import SystemUpdateAltOutlinedIcon from '@mui/icons-material/SystemUpdateAltOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FileDownloadDoneOutlinedIcon from '@mui/icons-material/FileDownloadDoneOutlined';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import ReportOutlinedIcon from '@mui/icons-material/ReportOutlined';
import DisabledByDefaultOutlinedIcon from '@mui/icons-material/DisabledByDefaultOutlined';
import NaturePeopleOutlinedIcon from '@mui/icons-material/NaturePeopleOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import DownloadingOutlinedIcon from '@mui/icons-material/DownloadingOutlined';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import ListOutlinedIcon from '@mui/icons-material/ListOutlined';
import TableRowsOutlinedIcon from '@mui/icons-material/TableRowsOutlined';
import DiscountOutlinedIcon from '@mui/icons-material/DiscountOutlined';
import StraightenOutlinedIcon from '@mui/icons-material/StraightenOutlined';

import { color } from '@mui/system';
import { use } from 'react';


const client = new Client()
    .setEndpoint(process.env.REACT_APP_ENDPOINT)
    .setProject(process.env.REACT_APP_PROJECT_ID);

const account = new AppAccount(client);
const teams = new Teams(client);
const storage = new Storage(client);
const databases = new Databases(client);


const setTheme = createTheme({
    cssVariables: {
        colorSchemeSelector: 'data-toolpad-color-scheme',
    },
    colorSchemes: {
        light: {
            palette: {
                background: {
                    default: '#F9F9FE',
                    paper: '#EEEEF9',
                },
            },
        },
        dark: {
            palette: {
                background: {
                    default: '#121212',
                    paper: '#121212',
                },
            },
        },
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 600,
            lg: 1200,
            xl: 1536,
        },
    },
});

// List of potential profile colors for accounts without a picture
const profileColors = [
    "#FFB3BA", "#FFDFBA", "#FFFFBA", "#BAFFC9", "#BAE1FF", "#FFABAB", "#FFC3A0", "#FF677D", "#D4A5A5", "#392F5A", "#B9FBC0", "#A0E7E5", "#B9FBC0", "#F9FBC0", "#F6B93B", "#F9AFAF"
];

// Container for page content
// Can have standard elements applied to it which will appear on all pages, like breadcrumbs or a footer
function PageContent({ pathname, page }) {
    return (<>{page}</>);
}

PageContent.propTypes = {
    pathname: PropTypes.string.isRequired,
};

function AccountSidebarPreview(props) {
    const { handleClick, open, mini } = props;
    return (
        <Stack direction="column" p={0}>
            <Divider />
            <AccountPreview
                variant={mini ? 'condensed' : 'expanded'}
                handleClick={handleClick}
                open={open}
            />
        </Stack>
    );
}

AccountSidebarPreview.propTypes = {
    /**
     * The handler used when the preview is expanded
     */
    handleClick: PropTypes.func,
    mini: PropTypes.bool.isRequired,
    /**
     * The state of the Account popover
     * @default false
     */
    open: PropTypes.bool,
};

function SidebarFooterAccountPopover() {
    const [userMembership, setUserMembership] = useAtom(TeamMember);
    const [userSession, setUserSession] = useAtom(UserSession);
    const [userMaster, setUserMaster] = useAtom(UserMaster);
    const [userOwner, setUserOwner] = useAtom(UserOwner);
    const [teamsList, setTeamsList] = useAtom(TeamsList);
    const [currentTeam, setCurrentTeam] = useAtom(CurrentTeam);
    const [teamURL, setTeamURL] = useAtom(TeamURL);

    const userAvatar = storage.getFileView(userSession.$id, 'avatar');

    function setColor(key, value) {
        const colors = getColor();
        colors[key] = value;
        localStorage.setItem('profileColors', JSON.stringify(colors));
    }
    
    function getColor(key) {
        const colorsString = localStorage.getItem('profileColors');
        const colors = colorsString ? JSON.parse(colorsString) : {};
        return key ? colors[key] : colors
    }

    // Set random color if currently unset
    useEffect(() => {
        if (!getColor(userSession.$id)) {
            setColor(userSession.$id, profileColors[Math.floor(Math.random() * profileColors.length)]);
        }
    })

    return (
        <Stack direction="column" sx={{ overflow: 'hidden' }}>
            <MenuList>
                <Stack
                    direction="row"
                    key={userSession.$id}
                    sx={{
                        mx: 2,
                        mb: 0.75,
                        justifyContent: 'flex-start',
                        width: '100%',
                        alignItems: 'center'
                    }}
                >
                    <ListItemIcon>
                        <Avatar
                            sx={{
                                width: 48,
                                height: 48,
                                fontSize: '0.95rem',
                                bgcolor: userAvatar ? '' : getColor(userSession.$id),
                            }}
                            src={userAvatar || ''}
                            alt={userSession.name || ''}
                        >
                            {userSession.name.replace(/[^A-Z]/g, '')}
                        </Avatar>
                    </ListItemIcon>
                    <ListItemText
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            width: '100%',
                        }}
                        primary={<Stack direction="row" alignItems="center" gap={1} sx={{ mb: 0.5 }}>
                            {userSession.name}
                            {(userOwner || (userMaster && teamsList[currentTeam] !== kebabToTitle(masterTeam))) &&
                                <Chip label={(userOwner && "Owner") || (userMaster && "TOM Admin")} size="small" sx={{ fontSize: '0.65rem' }}/>}
                        </Stack>}
                        secondary={userSession.email}
                    />
                </Stack>
                {teamsList.length > 0 && <Stack mb={1}>
                    <Typography textAlign="center" fontSize="0.625rem" gutterBottom>
                        User access managed by
                    </Typography>
                    <Box display="flex" justifyContent="center" alignItems="center" gap={2}>
                        <Avatar
                            variant="square"
                            src={logo}
                            alt={(userMaster && teamsList[currentTeam] !== kebabToTitle(masterTeam)) ? kebabToTitle(masterTeam) : teamsList[currentTeam]}
                            sx={{ width: 32, height: 32 }}
                        />
                        <Stack>
                        <Typography variant="caption" fontWeight="bolder">
                            {(userMaster && teamsList[currentTeam] !== kebabToTitle(masterTeam)) ? kebabToTitle(masterTeam) : teamsList[currentTeam]}
                        </Typography>
                        <Weblink
                            variant="caption"
                            href={teamURL}
                            target="_blank"
                            rel="noopener noreferrer"
                        >{teamURL?.replace("http://", "").replace("https://", "")}</Weblink>
                        </Stack>
                    </Box>
                </Stack>}
            </MenuList>
            <Divider />
            <AccountPopoverFooter>
                <SignOutButton />
            </AccountPopoverFooter>
        </Stack>
    );
}

const createPreviewComponent = (mini) => {
    function PreviewComponent(props) {
        return <AccountSidebarPreview {...props} mini={mini} />;
    }
    return PreviewComponent;
};

function SidebarFooterAccount({ mini }) {
    const PreviewComponent = React.useMemo(() => createPreviewComponent(mini), [mini]);
    return (<>
        <Account
            slots={{
                preview: PreviewComponent,
                popoverContent: SidebarFooterAccountPopover,
                // popoverFooter: UserOrg,
            }}
            slotProps={{
                popover: {
                    transformOrigin: { horizontal: 'left', vertical: 'bottom' },
                    anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
                    disableAutoFocus: true,
                    slotProps: {
                        paper: {
                            elevation: 0,
                            sx: {
                                overflow: 'visible',
                                filter: (theme) =>
                                    `drop-shadow(0px 2px 8px ${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.10)' : 'rgba(0,0,0,0.32)'})`,
                                mt: 1,
                                '&::before': {
                                    content: '""',
                                    display: 'block',
                                    position: 'absolute',
                                    bottom: 10,
                                    left: 0,
                                    width: 10,
                                    height: 10,
                                    bgcolor: 'background.paper',
                                    transform: 'translate(-50%, -50%) rotate(45deg)',
                                    zIndex: 0,
                                },
                            },
                        },
                    },
                },
            }}
        />
    </>);
}

SidebarFooterAccount.propTypes = {
    mini: PropTypes.bool.isRequired,
};


// TOP MENU BAR

function AppTitle(userTeams) {
    const navigate = useNavigate();

    const [userSession, setUserSession] = useAtom(UserSession);
    const [userMaster, setUserMaster] = useAtom(UserMaster);
    const [userOwner, setUserOwner] = useAtom(UserOwner);
    const [teamsList, setTeamsList] = useAtom(TeamsList);
    const [currentTeam, setCurrentTeam] = useAtom(CurrentTeam);
    const [teamURL, setTeamURL] = useAtom(TeamURL);
    
    const urlParams = new URLSearchParams(window.location.search);
    const team = urlParams.get('team') || localStorage.getItem('team');

    useEffect(() => {
        if (team) setCurrentTeam(userTeams.indexOf(kebabToTitle(team)));
    }, []);

    const getTeamURL = async () => {
        try {
            const metadata = await databases.getDocument(
                (userMaster && teamsList[currentTeam] !== kebabToTitle(masterTeam)) ?
                    masterTeam :
                    titleToKebab(teamsList[currentTeam]),
                'metadata',
                'main'
            );
            if (metadata.website !== teamURL) setTeamURL(metadata.website);
        } catch (error) {}
    }

    useEffect(() => {
        getTeamURL();
    }, []);

    return (
        <Stack direction="row" alignItems="center" spacing={2}>
            <Tooltip title="Takeoff Monkey Widgets">
                <Stack direction="row" alignItems="center">
                    <img
                        src={logo}
                        alt="Takeoff Monkey Logo"
                        style={{ height: '3em', cursor: 'pointer' }}
                        onClick={() => navigate('/')}
                    />
                </Stack>
            </Tooltip>
            {teamsList.length > 0 ? <>
                <Typography variant="h5" sx={{ cursor: 'default', userSelect: 'none' }}>+</Typography>
                <FormControl variant="outlined" size="small" sx={{ height: '4em' }}>
                    <Select
                        value={teamsList[currentTeam] || userTeams[0] || ""}
                        onChange={(event) => {
                            setCurrentTeam(userTeams.indexOf(event.target.value));
                            localStorage.setItem('team', titleToKebab(event.target.value));
                            urlParams.delete("team");
                            getTeamURL();
                            navigate({ search: urlParams.toString() });
                        }}
                        sx={{ fontSize: '1.2em', overflow: 'hidden' }}
                    >
                        {userTeams.map((team) => (
                            <MenuItem key={team} value={team}>
                                <Stack direction="row" alignItems="center">
                                    <img
                                        src={logo}
                                        alt="Takeoff Monkey Logo"
                                        style={{ height: '2em', marginRight: '0.5em' }}
                                    />
                                    {team}
                                </Stack>
                            </MenuItem>
                        ))}
                        {/* {userMaster && <>
                            <Divider />
                            <MenuItem
                                value=""
                                sx={{ justifyContent: 'center' }}
                                onClick={() => navigate('/admin/teams')}
                            >
                                +&nbsp;&nbsp;Create new team
                            </MenuItem>
                        </>} */}
                    </Select>
                </FormControl>
                <Chip size="small" sx={{ minWidth: 50 }} label="BETA" color="" />
            </> : <>
                <Chip size="small" sx={{ minWidth: 50 }} label="BETA" color="" />
                <Tooltip title="You are not part of any teams. Some functionality may not exist.">
                    <Stack direction="row" alignItems="center">
                        <Chip size="small" sx={{ minWidth: 50 }} label={<>&nbsp;NO TEAM&nbsp;</>} color="warning" />
                    </Stack>
                </Tooltip>
            </>}
        </Stack>
    );
}

function ToolbarActions({ drawerClick, drawerState, newJobs }) {
    return (<>
        <Tooltip
            title={drawerState ? 'Hide downloads' :
                newJobs > 0 ? `${newJobs} new download${newJobs > 1 ? 's' : ''}` : "View downloads"
        }>
            <IconButton
                color="inherit"
                onClick={drawerClick}
                edge="end"
                sx={{
                    mr: 2,
                    pl: 1.2,
                    pb: 1.2,
                    overflow: 'visible',
                }}
                className="no-scroll"
            >
                <Badge
                    badgeContent={newJobs}
                    color="primary"
                    sx={{
                        mr: 0.2,
                        mt: 0.2,
                        overflow: 'visible',
                    }}
                >
                    <SystemUpdateAltOutlinedIcon />
                </Badge>
            </IconButton>
        </Tooltip>
    </>);
}

function DownloadsDrawer({ page, drawerState, drawerClose, drawerRef, drawerMargin, drawerWidth, jobs, user, setNewJobs }) {
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [accordionExpanded, setAccordionExpanded] = useState(false);
    const [updatedJobs, setUpdatedJobs] = useState([]);

    // Showing notification for finished jobs
    useEffect(() => {
        if (drawerState) {
            // Reset is_new to false when drawer opens
            const newJobs = jobs.map(job => {
                return { ...job, is_new: false };
            });
            setUpdatedJobs(newJobs);

            setNewJobs(newJobs.filter(job => job.is_new).length);

            // Update is_new flag when drawer is opened
            jobs.forEach(async (job) => {
                if (job.is_new) {
                    try {
                        await databases.updateDocument(
                            'jobs',
                            user.$id,
                            job.$id,
                            { is_new: false }
                        );
                    } catch (error) {
                        console.error(`Error updating job ${job.$id}:`, error);
                    }
                }
            });
        } else {
            setNewJobs(jobs.filter(job => job.is_new).length);
        }
    }, [drawerState, jobs, setNewJobs]);

    function date(time) {
        return time ? new Date(time).toLocaleString() : "";
    }

    // Accordion component
    function DownloadDropdown(data, index) {
        const success = data?.files?.length - data?.error_names?.length;
        const failed = data?.error_names?.length;

        return (
            <Accordion
                key={data.$id}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                sx={{
                    backgroundColor: hoveredIndex === index ? 'rgba(108, 108, 108, 0.1)' : 'transparent',
                    transition: 'background-color 0.3s ease'
                }}
                expanded={accordionExpanded === index}
                onChange={() => setAccordionExpanded(accordionExpanded === index ? null : index)}
            >
                {/* Job header */}
                <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                    <Stack spacing={1.5} sx={{ width: "100%" }} >
                        <Stack direction="row" alignItems="center" spacing={2} >
                            <ListItem key={`header-${data.$id}`} disablePadding >
                                {/* Header icon */}
                                <Tooltip key={`tooltip-${data.$id}`} title={data?.progress < 100 ? "Processing..."
                                    : failed > 0 && success == 0 ? "Job failed"
                                    : failed > 0 && success > 0 ? "Some items failed to process"
                                    : "Successful job"
                                }>
                                    <ListItemIcon key={`icon-${data.$id}`}>
                                        {data?.progress < 100 ? <DownloadingOutlinedIcon />
                                            : success > 0 && failed == 0 ? <FileDownloadDoneOutlinedIcon />
                                            : failed > 0 && success > 0 ? <ReportOutlinedIcon />
                                            : <HighlightOffOutlinedIcon />
                                        }
                                    </ListItemIcon>
                                </Tooltip>
                                {/* Header text */}
                                <ListItemText key={`job-name-${data.$id}`} primary={<>
                                    <b>{data?.name ?
                                        data?.name?.split("_")[0].replace(/-/g, " ").replace(/\b\w/g, match => match.toUpperCase())
                                        : "Widget Job"
                                    }</b>
                                    &nbsp;&nbsp;{data?.start_time && "[ " + date(data?.start_time).split(" ")[1] + " ]"}
                                </>} />
                            </ListItem>
                        </Stack>
                        {/* Progress bar */}
                        {data?.progress < 100 && <Box
                            sx={{ display: 'flex', alignItems: 'center' }}
                        >
                            <Box sx={{ width: '100%', mr: 1 }}>
                                <LinearProgress variant="determinate" value={data?.progress} />
                            </Box>
                            <Box sx={{ minWidth: 35 }}>
                                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                    {`${Math.round(data?.progress)}%`}
                                </Typography>
                            </Box>
                        </Box>}
                    </Stack>
                </AccordionSummary>
                <AccordionDetails>
                    {/* Summary text */}
                    {data?.progress >= 100 ? <Typography>
                            {success > 0 && `${success} file${success === 1 ? "" : "s"} completed`}
                            {success > 0 && failed > 0 && ", "}
                            {failed > 0 && `${failed} file${failed === 1 ? "" : "s"} failed to process`}
                        </Typography>
                        : <Typography>
                            {data?.status || "Processing files..."}
                    </Typography>}
                    {/* Buttons */}
                    <Stack direction="row" spacing={2} sx={{ mt: '1.25em' }} >
                        {data?.progress >= 100 && <Button
                            variant="contained"
                            disabled={failed > 0 && success < 1}
                            href={storage.getFileDownload(`${user?.$id}_output`, data.$id)}
                            download
                        >
                            Download
                        </Button>}
                        {/* Widget Process Details Popup */}
                        {data?.progress >= 100 && <Popup
                            openText="View details"
                            openVariant="text"
                            header={data?.name?.split("_")[0].replace(/-/g, " ").replace(/\b\w/g, match => match.toUpperCase()) + " – Process Details"}
                            content={<>
                                {failed > 0 && <Alert icon={<ReportOutlinedIcon fontSize="inherit" />} severity="warning" >
                                    Some files failed to process; see associated logs for details.
                                </Alert>}
                                <Typography sx={{ mt: '1em' }} >
                                    {data?.start_time && data?.end_time &&
                                        (() => {
                                            const startTime = new Date(data?.start_time);
                                            const endTime = new Date(data?.end_time);
                                            const duration = endTime - startTime;

                                            // Convert duration to minutes and seconds
                                            const mins = Math.floor(duration / 60000);
                                            const secs = Math.round((duration % 60000) / 1000);

                                            return <>
                                                {`Started ${date(data?.start_time)}; Completed ${date(data?.end_time)}`}<br />
                                                <b>{`Duration: ${mins}m ${secs}s`}</b><br /><br />
                                            </>
                                        })()
                                    }
                                    <Typography variant="h6">{"Files processed: " + data?.files?.length}</Typography>
                                </Typography>
                                <List>
                                    {data?.files?.map((file, index) => (<>
                                        <ListItem key={data.$id}>
                                            {failed > 0 && data?.error_names?.includes(file)
                                                ? <HighlightOffOutlinedIcon />
                                                : <FileDownloadDoneOutlinedIcon />}
                                            <ListItemText key={`file-name-${data.$id}`} primary={file} sx={{ ml: '0.5em', minWidth: '35%' }} />
                                            <ListItemText
                                                key={`file-status-${data.$id}`}
                                                primary={
                                                    failed > 0 && data?.error_names?.includes(file) ?
                                                        data.error_logs[data.error_names.indexOf(file)]
                                                        : "Completed"
                                                }
                                                sx={{ ml: '0.5em', minWidth: '65%' }}
                                            />
                                        </ListItem>
                                    </>))}
                                </List>
                            </>}
                        />}
                    </Stack>
                </AccordionDetails>
            </Accordion>)
    }

    // Drawer layout
    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <Drawer
                ref={drawerRef}
                variant="persistent"
                anchor="right"
                open={drawerState}
            >
                <Stack direction="column">
                    <Stack
                        direction="row"
                        spacing={2}
                        sx={{
                            mt: `${drawerMargin}em`,
                            mb: '0.75em',
                            ml: '1em',
                            width: `${drawerWidth}px`,
                            minWidth: '400px',
                            alignItems: 'center',
                            overflow: 'visible'
                        }}
                    >
                        <Tooltip title="Hide downloads">
                            <IconButton onClick={drawerClose}>
                                <ChevronRightIcon />
                            </IconButton>
                        </Tooltip>
                        <Typography variant="h6">Downloads</Typography>
                    </Stack>
                    <Divider />
                    <Stack>
                        <List sx={{
                            mt: '0.5em',
                            ml: '1em',
                            width: `${drawerWidth}px`,
                            minWidth: '400px',
                            height: 'auto'
                        }}>
                            {updatedJobs.length > 0 ? [...updatedJobs].reverse().map((data, index) => (
                                DownloadDropdown(data, index)
                            ))
                            : <Stack key={`no-downloads`} sx={{ height: '100%', mt: `calc(50vh - ${drawerMargin * 3}em)`, alignItems: 'center', justifyContent: 'center' }}>
                                <CloudDownloadOutlinedIcon fontSize="large" color="disabled" sx={{ fontSize: '10em' }} />
                                <Typography
                                    variant="h3"
                                    sx={{
                                        mt: '0.5em',
                                        mb: '0.25em',
                                        fontSize: '2em',
                                        fontWeight: '',
                                        cursor: 'default',
                                        userSelect: 'none'
                                    }}
                                >
                                    <i>No downloads...</i>
                                </Typography>
                            </Stack>}
                        </List>
                    </Stack>
                </Stack>
            </Drawer>
            {page}
        </Box>
    );
}

function DashboardMenu({ path, needsOwner, needsMaster, page, jobStarted }) {
    const navigate = useNavigate();
    const [pathname, setPathname] = useState('');
    const accounts = useAccounts() || [];

    const [userSession, setUserSession] = useAtom(UserSession);
    const [userMaster, setUserMaster] = useAtom(UserMaster);
    const [userOwner, setUserOwner] = useAtom(UserOwner);
    const [teamsList, setTeamsList] = useAtom(TeamsList);
    const [currentTeam, setCurrentTeam] = useAtom(CurrentTeam);

    const userName = userSession?.name || 'Guest';
    const userEmail = userSession?.email || 'Not logged in';

    const theme = useTheme();
    const [drawerOpen, setDrawerOpen] = useState(false);
    const drawerRef = useRef(null);

    const [jobs, setJobs] = useState([]);
    const [newJobs, setNewJobs] = useState(0);


    // Get current session and account details
    useEffect(() => {
        // console.log("USER:", userSession)

        const getSession = async () => {
            try {
                const user = userSession || await account.get()

                if (user) {
                    setUserSession(user);
                    
                    // Check for master team member
                    const roles = await memberRoles(masterTeam, user.$id);
                    if (roles.includes('owner')) setUserMaster(true);
                    else {
                        setUserMaster(false);
                        if (needsMaster) navigate('/');
                    }

                    // Get list of user's teams (pulled from user's labels)
                    const userTeams = user.labels
                    if (userTeams) {
                        setTeamsList(userTeams.map(label => camelToTitle(label)));
                    }

                    // Check for team lead in current team
                    if (userTeams[currentTeam]) {
                        const teamRoles = await memberRoles(camelToKebab(userTeams[currentTeam]), user.$id);
                        if (teamRoles.includes('owner')) setUserOwner(true);
                        else {
                            setUserOwner(false);
                            if (needsOwner && !userMaster) navigate('/');
                        }
                    }
                }
            } catch (error) {
                console.error('Error in getSession:', error);
                navigate('/');
            }
        };
        getSession();
    }, [currentTeam]);

    // Get any realtime account changes
    useEffect(() => {
        const getProcs = async () => {
            databases.listDocuments(
                'jobs',
                userSession?.$id
            ).then(async result => {
                const expirationDate = new Date(Date.now() - 24 * 60 * 60 * 1000);
                const adjustedExpirationDate = new Date(expirationDate.getTime());

                const validJobs = result.documents.filter(doc => new Date(doc.$updatedAt) > adjustedExpirationDate);

                // Delete documents that are past the expiration date
                const expiredJobs = result.documents.filter(doc => new Date(doc.$updatedAt) <= adjustedExpirationDate);
                for (const job of expiredJobs) {
                    try {
                        await databases.deleteDocument('jobs', userSession.$id, job.$id);
                    } catch (error) {
                        console.error(`Error deleting job with ID ${job.$id}:`, error);
                    }
                }

                setJobs(validJobs);
            }).catch(error => {
                console.error(`Error fetching jobs documents for ${userSession?.$id}:`, error);
            });
        };

        if (userSession?.$id) {
            getProcs();

            const unsubscribe = client.subscribe(`databases.jobs.collections.${userSession?.$id}.documents`, response => {
                databases.listDocuments('jobs', userSession.$id).then(async result => {
                    // Set documents to automatically expire after 1 day
                    const expirationDate = new Date(Date.now() - 24 * 60 * 60 * 1000);
                    const adjustedExpirationDate = new Date(expirationDate.getTime());

                    const validJobs = result.documents.filter(doc => new Date(doc.$updatedAt) > adjustedExpirationDate);

                    // Delete documents that are past the expiration date
                    const expiredJobs = result.documents.filter(doc => new Date(doc.$updatedAt) <= adjustedExpirationDate);
                    for (const job of expiredJobs) {
                        try {
                            await databases.deleteDocument('jobs', userSession.$id, job.$id);
                        } catch (error) {
                            console.error(`Error deleting job with ID ${job.$id}:`, error);
                        }
                    }

                    setJobs(validJobs);
                }).catch(error => {
                    console.error(`Error fetching jobs documents for ${userSession.$id}:`, error);
                });
            });

            return () => unsubscribe();
        }
    }, []);

    // Sidebar menu
    const NAVIGATION = [
        {
            kind: 'header',
            title: userOwner || userMaster ? 'Administration' : 'Account',
        },
        {
            segment: '',
            title: 'Dashboard',
            icon: <DashboardIcon />,
        },
        ...(userMaster ? [
            {
                segment: 'admin',
                title: 'Admin Panel',
                icon: <AdminPanelSettingsOutlinedIcon />,
            },
        ] : []),
        ...(userOwner || userMaster ? [
            {
                segment: 'team',
                title: 'My Team',
                icon: <GroupsOutlinedIcon />,
            },
        ] : []),
        // {
        //     kind: 'header',
        //     title: 'Boards',
        // },
        // {
        //     segment: 'boards',
        //     title: 'Boards',
        //     icon: <TableRowsOutlinedIcon />,
        //     children: [
        //         {
        //             segment: 'example-board-1',
        //             title: 'Example Board 1'
        //         },
        //     ],
        // },
        {
            kind: 'header',
            title: 'Widgets',
        },
        {
            segment: 'widgets',
            title: 'Widgets',
            icon: <CategoryOutlinedIcon />,
            children: [
                {
                    segment: 'bid-scanner',
                    title: 'Bid Scanner',
                    icon: <ManageSearchOutlinedIcon />,
                },
                // {
                //     segment: 'irrigation-auditor',
                //     title: 'Irrigation Auditor',
                //     icon: <RuleOutlinedIcon />,
                // },
                // {
                //     segment: 'product-finder',
                //     title: 'Product Finder',
                //     icon: <DiscountOutlinedIcon />,
                // },
                {
                    segment: 'schedule-extractor',
                    title: 'Schedule Extractor',
                    icon: <DocumentScannerOutlinedIcon />,
                },
                {
                    segment: 'wall-height-calculator',
                    title: 'Wall Height Calculator',
                    icon: <StraightenOutlinedIcon />,
                }
            ],
        },
        ...(userOwner || userMaster ? [
            {
                segment: 'add-widgets',
                title: 'Add Widgets',
                icon: <LibraryAddIcon />,
                // icon: <DashboardCustomizeOutlinedIcon />,
            },
        ] : []),
        // {
        //     segment: 'help',
        //     title: 'Help',
        //     icon: <HelpOutlineOutlinedIcon />,
        // },
    ];

    const router = React.useMemo(() => {
        return {
            pathname,
            searchParams: new URLSearchParams(),
            navigate: (path) => {
                startTransition(() => {
                    setPathname(String(path));
                    navigate(path);
                })
            },
        };
    }, [pathname, navigate]);

    // TODO: update this session to reflect the actual session
    const createSession = {
        user: {
            name: userName,
            email: userEmail,
            color: profileColors[Math.floor(Math.random() * profileColors.length)],
        },
        org: {
            name: 'MUI Inc.',
            url: 'https://mui.com',
            logo: 'https://mui.com/static/logo.svg',
        },
    };

    const handleLogout = () => {
        logout().then(() => {
            setUserSession(null);
            navigate('/');
        });
    }

    const authentication = React.useMemo(() => {
        return {
            signIn: (user) => {
                setUserSession(user);
            },
            signOut: () => {
                handleLogout();
            },
        };
    }, [setUserSession]);

    const handleDrawerOpen = () => {
        setDrawerOpen(true);
    };

    const handleDrawerClose = () => {
        setDrawerOpen(false);
    };

    return (
        <AccountsProvider user={userSession?.name}>
            <div className="menu">
                <AppProvider
                    navigation={NAVIGATION}
                    router={router}
                    theme={setTheme}
                    authentication={authentication}
                    session={createSession}
                >
                    <DashboardLayout
                        defaultSidebarCollapsed={true}
                        slots={{
                            appTitle: () => AppTitle(teamsList),
                            toolbarAccount: () => null,
                            sidebarFooter: SidebarFooterAccount,
                            toolbarActions: () => <ToolbarActions drawerClick={drawerOpen ? handleDrawerClose : handleDrawerOpen} drawerState={drawerOpen} newJobs={newJobs} />,
                        }}
                        // key={currentTeam}
                    >
                        <DownloadsDrawer
                            page={
                                <PageContent key={currentTeam} pathname={pathname} page={page} />
                            }
                            drawerState={drawerOpen}
                            drawerClose={handleDrawerClose}
                            drawerRef={drawerRef}
                            drawerMargin="5"
                            drawerWidth={window.innerWidth / 3.5}
                            jobs={jobs}
                            user={userSession}
                            setNewJobs={setNewJobs}
                        />
                    </DashboardLayout>
                </AppProvider>
            </div>
        </AccountsProvider>
    );
}

export default DashboardMenu;